import React from "react"
import { FaTimes } from "react-icons/fa"
import myalgo from "../assets/images/myalgo.png"
import algosigner from "../assets/images/algosigner.png"

const Modal = ({ closeModal, toggle }) => {
  return (
    <div className={`${toggle ? "modal-overlay show-modal" : "modal-overlay"}`}>
      <div className="modal-container">
        <h3>Choose your Algorand wallet</h3>
        <button className="alogrand-btn btn">
          <img src={algosigner} alt="algosigner" className="blockchain-icons" />
          AlgoSigner
        </button>
        <button className="alogrand-btn btn">
          <img src={myalgo} alt="myalgo" className="blockchain-icons" />
          My Algo
        </button>
        <button className="close-modal-btn" onClick={closeModal}>
          <FaTimes></FaTimes>
        </button>
      </div>
    </div>
  )
}

export default Modal
